export const ORDER_MODIFICATION_REJECTION_REASON_MAX = 2000
